import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=072048cf&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072048cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072048cf')) {
      api.createRecord('072048cf', component.options)
    } else {
      api.reload('072048cf', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=072048cf&scoped=true&", function () {
      api.rerender('072048cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports